import setScrollBarWidth from 'set-scrollbar-width' // Use with the Tailwind Container Break Out extension.
import devMode from './dev-mode'
import { linksCustomization, scrollTo, responsiveTables } from './misc'
//import scrollAnimations from './scrollAnimations-v2';
import magnificPopup from './popups'
import { basicSlider } from './sliders'
import notifications from '../../templates/sections/notifications/notifications'
import { video } from './video'
import { bannerVideo } from '../../templates/sections/banner/banner-video'
import { wpGallery } from './galleries'

/* Flexible Content */
import accordion from '../../templates/blocks/accordion'
import whatWeDo from '../../templates/blocks/what-we-do/what-we-do'
import howWeWork from '../../templates/blocks/how-we-work/how-we-work'
import logosSwiper from '../../templates/blocks/logos-carousel'
import threeTeasersSwiper from '../../templates/blocks/three-teasers'
import callForInnovationSwiper from '../../templates/blocks/call-for-innovation'
import testimonialCarousel from '../../templates/blocks/testimonial-carousel'
import siteHeader from '../../templates/parts/site-menu/site-header'
import openCalls from '../../templates/open-call'

function consoleMessage() {
    console.log(
        '%cCreated by %cTWK%cwww.thewebkitchen.co.uk',
        'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;',
        'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;',
        'background: #FFFFFF; padding: 5px 10px;'
    )
}

function usingJS() {
    document.querySelector('html').classList.remove('no-js')
    document.querySelector('html').classList.add('js')
}

function updateUrlWithFilename() {
    document.addEventListener('click', (e) => {
        const element = e.target.closest('[data-filename]')
        if (element) {
            const url = new URL(window.location)
            const filename = element.getAttribute('data-filename')

            url.searchParams.set('file', filename)

            window.history.pushState({}, '', url)
        }
    })
}

/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function () {
    // Init
    consoleMessage()
    usingJS()
    setScrollBarWidth()
    siteHeader()

    // devMode();
    linksCustomization()
    scrollTo()
    responsiveTables()
    video()
    wpGallery()
    //scrollAnimations()
    notifications()
    bannerVideo()
    updateUrlWithFilename()
    openCalls()
    // Popups
    magnificPopup()

    // Sliders
    basicSlider()
    testimonialCarousel()

    // Flexible Content
    accordion()
    whatWeDo()
    howWeWork()
    logosSwiper()
    threeTeasersSwiper()
    callForInnovationSwiper()
}

jQuery(document).ready(function ($) {
    ajax: {
        /**
         * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
         */
        // $(document).on('sf:ajaxfinish', '.searchandfilter', function () {
        //     magnificPopupIframe()
        //     magnificPopupInline()
        //     magnificPopupSingleImage()
        //     magnificPopupGalleryImage()
        // })
    }
})
